import RegWidget from './RegWidget';
const regEl = document.querySelector('.reg');
if (regEl) {
    regEl.regWidget = new RegWidget(regEl);
}
const resetRegForm = () => {
    var _a;
    const regEl = document.querySelector('.reg');
    (_a = regEl === null || regEl === void 0 ? void 0 : regEl.regWidget) === null || _a === void 0 ? void 0 : _a.resetForm();
};
const resetRegStorage = () => {
    var _a;
    const regEl = document.querySelector('.reg');
    (_a = regEl === null || regEl === void 0 ? void 0 : regEl.regWidget) === null || _a === void 0 ? void 0 : _a.resetStorage();
};
window.resetRegForm = resetRegForm;
window.resetRegStorage = resetRegStorage;
